/* ============================================================
   DONNÉES ROYALES — HUILLERIES DIW'LINE
   Maison de Sa Majesté Adjia Daba NDIAYE · Fondation 1958 · Dakar
   ============================================================ */

export const IMG = "/images/diwline";

export const MAISON = {
  nom: "DIW'LINE",
  devise: "Jàmm ak Nànk — Jëfandikukay Sénégal",
  signature: "L'or liquide du Sénégal",
  fondation: "Fondation 1958",
  ville: "Dakar, Sénégal",
  souveraine: "Sa Majesté Adjia Daba NDIAYE",
  domain: "AdjiaDabaNdiaye.Ligue-Islamique.biz",
  recommandation:
    "Son Excellence le Président Ndongo NDIAYE recommande de développer, à la limite de l'ingéniosité et de la technologie, le site des Huilleries DIW'LINE.",
};

/* ================= ŒUVRES ROYALES ================= */

export type Categorie =
  | "Huilerie"
  | "Agriculture"
  | "Produits"
  | "Portraits Royaux"
  | "Gastronomie"
  | "Célébrations"
  | "Digital & Innovation"
  | "Symboles";

export interface Oeuvre {
  src: string;
  titre: string;
  categorie: Categorie;
  description: string;
}

export const OEUVRES: Oeuvre[] = [
  // --- Huilerie ---
  { src: `${IMG}/huilerie.jpg`, titre: "Cuves Dorées — Huilerie Royale Moderne", categorie: "Huilerie", description: "Cuves d'or, techniciens royaux, flux d'or pur — chaque détail est digne d'un patrimoine de cour." },
  { src: `${IMG}/embouteillage.jpg`, titre: "Emboutelage de Luxe", categorie: "Huilerie", description: "Le geste précis des artisans qui scellent l'or liquide dans ses écrins de verre." },
  { src: `${IMG}/visite-royale.jpg`, titre: "Visite Royale de l'Huilerie", categorie: "Huilerie", description: "Sa Majesté Adjia Daba visitant son huilerie royale moderne, inspectant le flux d'huile dorée." },
  // --- Agriculture ---
  { src: `${IMG}/champs-arachide.jpg`, titre: "Champs d'Arachide", categorie: "Agriculture", description: "Nos champs dorés s'étendent à perte de vue — terroir bénia de la souveraineté nourricière." },
  { src: `${IMG}/palmiste.jpg`, titre: "Récolte de Palmistes Dorés", categorie: "Agriculture", description: "Les régimes magnifiques du palmier royal, cueillis dans le respect de la tradition." },
  { src: `${IMG}/reine-nourriciere.jpg`, titre: "Portrait d'Agricultultrice Royale — Reine Nourricière", categorie: "Agriculture", description: "L'émancipation féminine incarnée : la Reine Nourricière veille sur les récoltes du royaume." },
  { src: `${IMG}/sesame.jpg`, titre: "Plantation de Sésame", categorie: "Agriculture", description: "Épis graciles et capsules dorées : le sésame noble des terres du Sénégal." },
  { src: `${IMG}/macro-graines.jpg`, titre: "Macro d'Épis et Graines Dorées — Offrande Royale", categorie: "Agriculture", description: "L'offrande de la terre au royaume : graines choisies, épis d'or, promesse d'abondance." },
  { src: `${IMG}/karite-femmes.jpg`, titre: "Les Gardiennes du Karité", categorie: "Agriculture", description: "Le savoir-faire séculaire des femmes qui transforment la noix en beurre précieux." },
  // --- Produits ---
  { src: `${IMG}/produit-palme.jpg`, titre: "Huile de Palme Rouge", categorie: "Produits", description: "Rubis liquide des terroirs du Sud, pressée selon le rite ancestral." },
  { src: `${IMG}/produit-sesame.jpg`, titre: "Huile de Sésame Dorée", categorie: "Produits", description: "L'or pâle parfumé, noble et délicat, signature des tables raffinées." },
  { src: `${IMG}/produit-karite.jpg`, titre: "Beurre de Karité Pur", categorie: "Produits", description: "Ivoire nourricier, trésor de douceur façonné par les mains des gardiennes." },
  { src: `${IMG}/produit-tournesol.jpg`, titre: "Huile de Tournesol Impériale", categorie: "Produits", description: "Clarté solaire sous sceau impérial — la légèreté en majesté." },
  { src: `${IMG}/produit-coffret.jpg`, titre: "Coffret Royal Découverte", categorie: "Produits", description: "Quatre joyaux de l'or liquide réunis dans un écrin de velours bordeaux brodé d'or." },
  // --- Portraits Royaux ---
  { src: `${IMG}/majeste-portrait.jpg`, titre: "Portrait Officiel de Sa Majesté Adjia Daba", categorie: "Portraits Royaux", description: "Robe bordeaux royale brodée d'or — la majesté au service de la Nation." },
  { src: `${IMG}/patriotisme.jpg`, titre: "Patriotisme Royal", categorie: "Portraits Royaux", description: "Portrait patriotique de Sa Majesté Daba devant le drapeau du Sénégal." },
  { src: `${IMG}/icone-nation.jpg`, titre: "Icône de la Nation", categorie: "Portraits Royaux", description: "Composition symbolique : silhouette royale encadrée par le sceau DIW'LINE en halo doré." },
  { src: `${IMG}/dame-lion-portrait.jpg`, titre: "La Dame au Lion — Gardienne du Patrimoine", categorie: "Portraits Royaux", description: "Œuvre d'apparat de la Collection DIW'LINE : la souveraine auprès du lion de bronze, gardien des institutions." },
  // --- Gastronomie ---
  { src: `${IMG}/recette-thieboudienne.jpg`, titre: "Thieboudienne Royal — par Penda Mbaye", categorie: "Gastronomie", description: "Le plat national sublimé par l'huile de palme rouge DIW'LINE." },
  { src: `${IMG}/recette-mafe.jpg`, titre: "Mafé d'Honneur", categorie: "Gastronomie", description: "La sauce d'arachide noble, onctueuse et profonde, digne des grandes tablées." },
  { src: `${IMG}/recette-yassa.jpg`, titre: "Yassa Poulet Royal", categorie: "Gastronomie", description: "Oignons caramélisés au doré de sésame, citron noble et parfums du terroir." },
  { src: `${IMG}/recette-kandia.jpg`, titre: "Soupe Kandia Nourricière", categorie: "Gastronomie", description: "Le gombo vert émeraude couronné de gouttes d'or liquide." },
  { src: `${IMG}/recette-avocat.jpg`, titre: "Salade d'Avocat Royale", categorie: "Gastronomie", description: "Fraîcheur impériale, huile de tournesol et fleurs comestibles." },
  { src: `${IMG}/recette-beignets.jpg`, titre: "Beignets de Karité Sucrés", categorie: "Gastronomie", description: "La douceur peule revisitée, dorée au beurre de karité pur." },
  // --- Célébrations ---
  { src: `${IMG}/fete-royale.jpg`, titre: "Moments de Fête Royale", categorie: "Célébrations", description: "L'union de la noblesse sénégalaise et de l'élégance d'apparat, esprit de communion et de grandeur." },
  // --- Digital & Innovation ---
  { src: `${IMG}/digital-royal.jpg`, titre: "L'Ingénieure du Sursaut", categorie: "Digital & Innovation", description: "La connexion digitale royale : technologie de pointe au service de la souveraineté nourricière." },
  // --- Symboles ---
  { src: `${IMG}/dame-lion.jpg`, titre: "Paysage avec Lion Doré Stylisé — Gardien Royal", categorie: "Symboles", description: "Le lion de la savane dorée veille sur les champs du royaume." },
  { src: `${IMG}/export-mondial.jpg`, titre: "Or du Sénégal aux Quatre Coins", categorie: "Symboles", description: "Nos ambassades commerciales portent l'excellence sénégalaise dans les capitales les plus prestigieuses." },
  { src: `${IMG}/hero.jpg`, titre: "De Nos Champs Dorés aux Tables du Monde", categorie: "Symboles", description: "L'aube sur les terres dorées du Sénégal — le berceau de l'or liquide." },
];

/* ================= PRODUITS ================= */

export interface Produit {
  nom: string;
  image: string;
  essence: string;
  description: string;
  badge: string;
}

export const PRODUITS: Produit[] = [
  {
    nom: "Huile de Palme Rouge",
    image: `${IMG}/produit-palme.jpg`,
    essence: "Rubis du terroir · Première pression",
    description:
      "Joyau carmin extrait des régimes mûrs du palmier royal, riche en tocotriénols et en carotène. Sa robe flamboyante et son parfum de terroir ennobissent le thieboudienne comme les grandes cérémonies.",
    badge: "Signature Royale",
  },
  {
    nom: "Huile de Sésame Dorée",
    image: `${IMG}/produit-sesame.jpg`,
    essence: "Or pâle · Torréfaction noble",
    description:
      "Pressée à froid depuis les capsules dorées de nos plantations, elle libère un parfum délicat de noisette. L'alliée des vinaigrettes impériales et des plats fins de la gastronomie mondiale.",
    badge: "Pressée à Froid",
  },
  {
    nom: "Beurre de Karité Pur",
    image: `${IMG}/produit-karite.jpg`,
    essence: "Ivoire nourricier · Non raffiné",
    description:
      "Façonné par les gardiennes du karité selon un savoir-faire séculaire, ce beurre d'ivoire nourrit la peau, les cheveux et les plats sucrés. Le trésor d'émancipation des femmes du royaume.",
    badge: "Émancipation Féminine",
  },
  {
    nom: "Huile de Tournesol Impériale",
    image: `${IMG}/produit-tournesol.jpg`,
    essence: "Clarté solaire · Légèreté en majesté",
    description:
      "Une huile limpide et solaire, douce pour les fritures nobles comme pour les dressages délicats. Sous son sceau impérial, elle porte la lumière des champs du Sénégal sur toutes les tables.",
    badge: "Sceau Impérial",
  },
  {
    nom: "Coffret Royal Découverte",
    image: `${IMG}/produit-coffret.jpg`,
    essence: "Écrin de velours bordeaux brodé d'or",
    description:
      "Quatre joyaux de l'or liquide réunis dans un coffret d'apparat. Le cadeau de cour par excellence — pour offrir la grandeur du Sénégal aux quatre coins du monde.",
    badge: "Édition d'Apparat",
  },
];

/* ================= PROCESSUS ROYAL ================= */

export interface Etape {
  numero: string;
  titre: string;
  texte: string;
  icone: "sprout" | "hand" | "factory" | "gem" | "truck" | "globe";
}

export const ETAPES: Etape[] = [
  {
    numero: "I",
    titre: "Agriculture Royale",
    texte: "Des semences choisies et un smart farming de précision nourrissent nos champs dorés, dans le respect de la terre et des communautés.",
    icone: "sprout",
  },
  {
    numero: "II",
    titre: "Récolte Digne",
    texte: "Chaque graine, chaque noix est cueillie à maturité par nos coopératives de Reines Nourricières, garantes d'un travail équitable et dignifié.",
    icone: "hand",
  },
  {
    numero: "III",
    titre: "Transformation Moderne",
    texte: "Nos huileries de dernière génération marient ingéniosité africaine et islamique, innovation scientifique et tradition ancestrale.",
    icone: "factory",
  },
  {
    numero: "IV",
    titre: "Embouteillage de Luxe",
    texte: "L'or liquide est scellé dans des écrins de verre aux cachets d'or — chaque flacon est une œuvre digne d'un patrimoine de cour.",
    icone: "gem",
  },
  {
    numero: "V",
    titre: "Distribution Royale",
    texte: "Nos maisons de distribution veillent sur chaque commande, du comptoir de Dakar aux épiceries fines des cinq continents.",
    icone: "truck",
  },
  {
    numero: "VI",
    titre: "Export Mondial",
    texte: "De l'Afrique à l'Oummah, des Amériques à l'Asie : l'excellence sénégalaise rayonne dans les capitales les plus prestigieuses.",
    icone: "globe",
  },
];

/* ================= RECETTES ROYALES ================= */

export interface Recette {
  titre: string;
  chef: string;
  image: string;
  huile: string;
  description: string;
}

export const RECETTES: Recette[] = [
  {
    titre: "Thieboudienne Royal",
    chef: "Penda Mbaye",
    image: `${IMG}/recette-thieboudienne.jpg`,
    huile: "Huile de Palme Rouge",
    description:
      "Le riz au poisson national, élevé au rang de cour par la légendaire Penda Mbaye : riz brisé parfumé, poissons de l'Atlantique, légumes du royaume et la robe carminée de notre huile de palme rouge.",
  },
  {
    titre: "Mafé d'Honneur",
    chef: "Maison DIW'LINE",
    image: `${IMG}/recette-mafe.jpg`,
    huile: "Huile de Palme Rouge",
    description:
      "La sauce d'arachide des grandes tablées : mijotée des heures, elle gagne une profondeur veloutée grâce à une touche d'or liquide servie en fin de cuisson.",
  },
  {
    titre: "Yassa Poulet Royal",
    chef: "Maison DIW'LINE",
    image: `${IMG}/recette-yassa.jpg`,
    huile: "Huile de Sésame Dorée",
    description:
      "Oignons confits au citron, poulet mariné et riz fumé : l'huile de sésame dorée sublime le caramel d'oignons d'une note noble et délicate.",
  },
  {
    titre: "Soupe Kandia Nourricière",
    chef: "Maison DIW'LINE",
    image: `${IMG}/recette-kandia.jpg`,
    huile: "Huile de Palme Rouge",
    description:
      "Le gombo émeraude des rivages, couronné de perles d'or liquide : une soupe de communion qui nourrit le corps et l'esprit.",
  },
  {
    titre: "Salade d'Avocat Royale",
    chef: "Maison DIW'LINE",
    image: `${IMG}/recette-avocat.jpg`,
    huile: "Huile de Tournesol Impériale",
    description:
      "Fraîcheur impériale : avocats crémeux, agrumes du verger et voile d'huile de tournesol impériale sur un lit de fleurs comestibles.",
  },
  {
    titre: "Beignets de Karité Sucrés",
    chef: "Tradition Peule",
    image: `${IMG}/recette-beignets.jpg`,
    huile: "Beurre de Karité Pur",
    description:
      "La douceur peule transmise de mère en fille : des beignets aériens frits au beurre de karité, nappés de miel et de sucre impérial.",
  },
];

/* ================= CONNEXION DIGITALE ================= */

export interface Pilier {
  titre: string;
  texte: string;
  icone: "cpu" | "coins" | "landmark" | "award";
}

export const PILIERS: Pilier[] = [
  {
    titre: "L'Ingénieure du Sursaut",
    texte: "Un pôle d'ingénierie digitale dirigé par des femmes d'excellence : IoT des champs, traçabilité blockchain et smart farming au service de l'or liquide.",
    icone: "cpu",
  },
  {
    titre: "Finance Inclusive Nobiliaire",
    texte: "La microfinance royale accompagne les coopératives féminines et la jeunesse entrepreneuriat : chaque goutte d'or finances un destin.",
    icone: "coins",
  },
  {
    titre: "Sursaut National Or",
    texte: "Le grand programme de souveraineté nourricière : valoriser les oléagineux sénégalais pour que le Sénégal nourrisse l'Afrique.",
    icone: "landmark",
  },
  {
    titre: "Ambassadrice Yacine",
    texte: "Notre ambassadrice de prestige porte la voix de DIW'LINE dans les capitales du monde et auprès de l'Oummah, fidèle à l'esprit de la Maison.",
    icone: "award",
  },
];

/* ================= GALERIES ================= */

export const PATRIMOINE_PHARES: Oeuvre[] = [
  OEUVRES.find(o => o.titre.includes("Dame au Lion"))!,
  OEUVRES.find(o => o.titre.includes("Cuves Dorées"))!,
  OEUVRES.find(o => o.titre.includes("Champs d'Arachide"))!,
  OEUVRES.find(o => o.titre.includes("Reine Nourricière"))!,
  OEUVRES.find(o => o.titre.includes("Offrande Royale"))!,
  OEUVRES.find(o => o.titre.includes("Gardiennes du Karité"))!,
  OEUVRES.find(o => o.titre.includes("Emboutelage"))!,
  OEUVRES.find(o => o.titre.includes("Fête Royale"))!,
  OEUVRES.find(o => o.titre.includes("Ingénieure du Sursaut"))!,
  OEUVRES.find(o => o.titre.includes("Gardien Royal"))!,
  OEUVRES.find(o => o.titre.includes("Coffret Royal Découverte"))!,
  OEUVRES.find(o => o.titre.includes("Thieboudienne"))!,
];

export const NDIAMSYL: Oeuvre[] = [
  OEUVRES.find(o => o.titre.startsWith("De Nos Champs"))!,
  OEUVRES.find(o => o.titre.includes("Plantation de Sésame"))!,
  OEUVRES.find(o => o.titre.includes("Palmistes"))!,
  OEUVRES.find(o => o.titre.includes("Portrait d'Agricultultrice"))!,
  OEUVRES.find(o => o.titre.includes("Macro"))! ? OEUVRES.find(o => o.titre.includes("Macro"))! : OEUVRES[0],
  OEUVRES.find(o => o.titre.includes("Patriotisme"))!,
  OEUVRES.find(o => o.titre.includes("Cuves Dorées"))!,
  OEUVRES.find(o => o.titre.includes("Gardiennes du Karité"))!,
  OEUVRES.find(o => o.titre.includes("Icône de la Nation"))!,
  OEUVRES.find(o => o.titre.includes("Fête Royale"))!,
  OEUVRES.find(o => o.titre.includes("Quatre Coins"))!,
  OEUVRES.find(o => o.titre.includes("Gardien Royal"))!,
];

export interface Album {
  titre: string;
  phase: string;
  couverture: string;
  description: string;
  images: Oeuvre[];
}

export const ALBUMS: Album[] = [
  {
    titre: "Agriculture Oléagineuse",
    phase: "Phase 2",
    couverture: `${IMG}/sesame.jpg`,
    description: "Clichés inédits de nos plantations d'oléagineux nobles, de l'épi doré à la graine choisie.",
    images: [
      OEUVRES.find(o => o.titre.includes("Plantation de Sésame"))!,
      OEUVRES.find(o => o.titre.includes("Champs d'Arachide"))!,
      OEUVRES.find(o => o.titre.includes("Offrande Royale"))!,
    ],
  },
  {
    titre: "Récolte de Palmiers",
    phase: "Phase 2",
    couverture: `${IMG}/palmiste.jpg`,
    description: "La majesté des palmeraies royales et l'art de la cueillette des régimes dorés.",
    images: [
      OEUVRES.find(o => o.titre.includes("Palmistes"))!,
      OEUVRES.find(o => o.titre.includes("Cuves Dorées"))!,
    ],
  },
  {
    titre: "Beurre & Lait",
    phase: "Phase 2",
    couverture: `${IMG}/karite-femmes.jpg`,
    description: "Le voyage de la noix de karité au beurre d'ivoire — et la douceur des laits du royaume.",
    images: [
      OEUVRES.find(o => o.titre.includes("Gardiennes du Karité"))!,
      OEUVRES.find(o => o.titre.includes("Beurre de Karité Pur"))!,
      OEUVRES.find(o => o.titre.includes("Beignets"))!,
    ],
  },
];

export const PORTRAITS: Oeuvre[] = [
  OEUVRES.find(o => o.titre.includes("Portrait Officiel"))!,
  OEUVRES.find(o => o.titre.includes("Visite Royale"))!,
  OEUVRES.find(o => o.titre.includes("Patriotisme"))!,
  OEUVRES.find(o => o.titre.includes("Icône de la Nation"))!,
];

export const ROMAN_PORTRAITS = ["XIII", "XIV", "XV", "XVI"];

/* ================= EXPORT MONDIAL ================= */

export const CAPITALES: { ville: string; region: string }[] = [
  { ville: "Dakar", region: "Siège de la Maison · Sénégal" },
  { ville: "La Mecque & Médine", region: "Oummah · Arabie" },
  { ville: "Dubaï", region: "Golfe Prestige · Émirats" },
  { ville: "Paris", region: "Épiceries Fines · France" },
  { ville: "Londres", region: "Maisons de Cour · Royaume-Uni" },
  { ville: "Bruxelles", region: "Capitale Européenne · Belgique" },
  { ville: "New York", region: "Amérique du Nord · É-U" },
  { ville: "Casablanca", region: "Cherifat des Saveurs · Maroc" },
  { ville: "Abidjan", region: "Cœur Éburnéen · Côte d'Ivoire" },
  { ville: "Le Caire", region: "Vallée du Nil · Égypte" },
  { ville: "Kuala Lumpur", region: "Asie Dorée · Malaisie" },
  { ville: "São Paulo", region: "Amérique du Sud · Brésil" },
];

/* ================= NAVIGATION ================= */

export const NAV_LINKS: { label: string; href: string }[] = [
  { label: "Accueil", href: "#accueil" },
  { label: "L'Or Liquide", href: "#or-liquide" },
  { label: "Produits", href: "#produits" },
  { label: "Recettes", href: "#recettes" },
  { label: "Catalogue", href: "#catalogue" },
  { label: "JOUDI", href: "#joudi" },
  { label: "Galeries", href: "#patrimoine" },
  { label: "Œuvres", href: "#oeuvres" },
  { label: "Portraits", href: "#portraits" },
  { label: "Contact", href: "#contact" },
];

/* ================= MAISONS & FONDATIONS ASSOCIÉES ================= */

export const SITES_ASSOCIES: { label: string; url: string }[] = [
  { label: "Boutique Impériale JOUDI — 御店", url: "https://boutique.joudi.online" },
  { label: "JOUDI — L'Eau des Rois", url: "https://joudi.online" },
  { label: "Seyedina Muhammad Éditions — Médine", url: "https://seydinamuhammadeditions.com/Medine/" },
  { label: "Éditions Médine — Collection Matar", url: "https://seydinamuhammadeditions.com/Medine/Matar" },
  { label: "Empire Royal Poulet de Fatima", url: "https://pouletDeFatima.online" },
  { label: "Fondation Al-Maoun", url: "https://www.Al-Maoun.online" },
  { label: "Ndiamsyl Mody — Héritage Royal", url: "https://ndiamsyl-mody.online/mody/2/" },
];
